import { FC, useEffect, useState } from 'react';
import { FaTrash } from 'react-icons/fa';
import FormGroup from 'components/form/FormGroup';
import { ISelectOptionProps, ISelectGroupProps } from 'components/form/types';
import Button from 'components/Button';
import TooltipWrapper from 'components/TooltipWrapper';
import { useTranslation } from 'react-i18next';

interface IProps {
  id: number;
  name: string;
  options: ISelectGroupProps[];
  selected: ISelectOptionProps[];
  updateData: (actions: any) => void;
  removeItem: (option: any) => void;
  position: number;
  methods: any;
  hasPermission?: boolean;
}
const ActionCell: FC<IProps> = ({
  id,
  methods,
  name,
  options,
  selected,
  updateData,
  removeItem,
  position,
  hasPermission,
}) => {
  const [selectOptions, setSelectOptions] = useState(options);
  const selectedValue = methods.watch(name);

  const { t } = useTranslation();

  const disableSelected = () => {
    const updatedOptions = options.map(group => ({
      ...group,
      options: group?.options?.map(opt => {
        const isBetweenSelected = selected.find(sel => sel?.value === opt.value);
        const isCurrentValue = selectedValue?.value === opt.value;
        return {
          ...opt,
          isDisabled: !!isBetweenSelected && !isCurrentValue,
        };
      }),
    }));

    setSelectOptions(updatedOptions);
  };

  useEffect(() => {
    // Get positions selected
    const updatedSelected = selected.map((sel, index) => {
      if (index === position) return selectedValue;

      return sel;
    });

    updateData(updatedSelected);
  }, [selectedValue]);

  useEffect(() => {
    disableSelected();
  }, []);

  useEffect(() => {
    disableSelected();
  }, [selected]);

  return (
    <div className="d-flex align-items-center">
      <FormGroup
        controlId={`formGroup-${name}`}
        type="select"
        as="select"
        name={name}
        isDisabled={!hasPermission}
        isRequired
        isClearable
        isSearchable
        selectOptions={selectOptions}
        formGroupClassName="mb-2 mr-1"
        style={{ width: '100%' }}
      />
      <TooltipWrapper
        id="tooltip-trash"
        overlay={hasPermission ? t('common.delete') : t('common.noPermission')}
      >
        <Button
          className="mb-2"
          btnType="danger"
          size="sm"
          outlined
          disabled={!hasPermission}
          onClick={() => removeItem(id)}
          preventDebounce
        >
          <FaTrash size={14} />
        </Button>
      </TooltipWrapper>
    </div>
  );
};

export default ActionCell;
